import { render } from "./number.vue?vue&type=template&id=6141b17a&scoped=true"
import script from "./number.vue?vue&type=script&lang=js"
export * from "./number.vue?vue&type=script&lang=js"

import "./number.vue?vue&type=style&index=0&id=6141b17a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6141b17a"]])

export default __exports__